import type { RentalStatusQuoteFormInput } from 'app/home/create-quote/forms/rental-status/rental-status.types';
import type { QuoteDraftSelectorState } from 'app/home/global-store/quote-draft';
import type { QuoteFormOptionsSelectorState } from 'app/home/global-store/quote-form-options';

export function rentalStatusQuoteFormSelector(store: QuoteDraftSelectorState): RentalStatusQuoteFormInput {
  const rentalStatus = store.rentalStatus();
  return { rentalStatus };
}

export function rentalStatusQuoteFormOptionsSelector(store: QuoteFormOptionsSelectorState) {
  return store['rental-status']();
}
